import { render, staticRenderFns } from "./CustomerDetailsCard.vue?vue&type=template&id=3f42d5f6&scoped=true&"
import script from "./CustomerDetailsCard.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetailsCard.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDetailsCard.vue?vue&type=style&index=0&id=3f42d5f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f42d5f6",
  null
  
)

export default component.exports